import type { PropsWithChildren } from "react";

export function SessionFormsLayout({ children }: PropsWithChildren) {
  return (
    <div className="w-full max-w-2/6 mx-auto border-l border-r px-16 flex flex-col items-center justify-center h-screen">
      {children}
    </div>
  );
}
